// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"120":"1b87c029b2d1f8e7f995","856":"c6aad2ef6fc08e5b0efb","894":"31f574259088b3334ce6"}[chunkId] + ".js";
};